export default "__VITE_PUBLIC_ASSET__09b05ac2__"